'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _get = require('lodash/get');
var _get2 = _interopRequireDefault(_get);
var _requestMiddleware = require('./request-middleware');
var _responseMiddleware = require('./response-middleware');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var isAuthResponseAction = function isAuthResponseAction(action) {
  return (0, _get2.default)(action, 'meta.authRequest') === true;
};
var isAuthRequestAction = function isAuthRequestAction(action) {
  return Boolean(action.auth && action.request);
};
var authMiddleware = function authMiddleware(store) {
  return function (next) {
    return function (action) {
      if (isAuthResponseAction(action)) return (0, _responseMiddleware.responseMiddleware)(store, next, action);
      if (isAuthRequestAction(action)) return (0, _requestMiddleware.requestMiddleware)(store, next, action);
      return next(action);
    };
  };
};
exports.default = authMiddleware;